// Contracts configuration based on user provided JSON structure
export const contractsConfig = {
  "contract_types": [
    {
      "id": "arras_penitenciales",
      "name": "Contrato de Arras Penitenciales",
      "description": "Contrato de arras penitenciales para compraventa de vivienda",
      "template": {
        "title": "CONTRATO DE ARRAS PENITENCIALES",
        "content": `En Barcelona a {fecha_dia} de {fecha_mes} de {fecha_año}

REUNIDOS

De una parte, la sociedad mercantil Investments Made Easy, S.L., cuyo representante legal es Joan Freixa Porredon mayor de edad, con DNI nº 14270239G y con domicilio societario en Carrer Méndez Núñez, nº 8, 08003, Barcelona (Barcelona) y C.I.F. nº B67108373

Y de otra, {compradores_info}, mayores de edad, con domicilios respectivos en {compradores_domicilios} y con números de DNI/NIE {compradores_dni_nie},

ACTÚAN

Todas las partes, en su propio nombre y se reconocen mutuamente la capacidad legal necesaria para el presente otorgamiento, y la asunción de las obligaciones que en el mismo dimanan, y de su libre y espontánea voluntad,

MANIFIESTAN

Que la sociedad mercantil Investments Made Easy, S.L. es dueña de la vivienda sita en {direccion_vivienda}, con referencia catastral número {referencia_catastral} y CRU nº {cru_numero} e inscrita en el Registro de la Propiedad nº {registro_propiedad_numero} de {registro_propiedad_lugar}, Finca nº {finca_numero}, Tomo {tomo}, Libro {libro}, Folio {folio}, inscripción {inscripcion_numero}ª, encontrándose la finca libre de toda carga, gravamen o limitación.

Que {compradores_referencia} (en adelante, {compradores_etiqueta}) {compradores_verbo_estan} interesados en la adquisición de la finca descrita, por lo que el día de la firma del presente contrato justifican, mediante transferencia bancaria al número de cuenta bancaria IBAN ES11 0182 1921 21 0201542238 (BBVA) el importe de {importe_arras}€ ({importe_arras_letras} euros), en concepto de arras penitenciales, cuyos efectos están legalmente previstos en el artículo 1.454 del Código Civil español. En este sentido, la efectividad de este contrato de Arras queda supeditada a la recepción de dicho importe en la cuenta de destino descrita, cuya titularidad corresponde unívocamente a los titulares de la finca.

El precio de la venta se establece en {precio_venta}€ ({precio_venta_letras} euros), del que deberá deducirse la cantidad total transferida hoy en concepto de Arras ({importe_arras}€) y los {importe_reserva}€ abonados en concepto de Reserva de la vivienda.

El pago de Arras entregado tendrá validez máxima hasta el día {fecha_limite_dia} de {fecha_limite_mes} de {fecha_limite_año}, día límite para formalizar la escritura pública de compraventa.

La escritura se formalizará en la Notaría que a tales efectos designe la parte compradora, debiendo notificar a la parte vendedora de forma fehaciente con una antelación de, al menos, cinco días, el lugar día y hora para su otorgamiento. La parte compradora se reserva el Derecho para que la escritura pública de compraventa sea otorgada a favor de la persona que ésta libremente designe.

La entrega de llaves se llevará a cabo en el momento de la firma de la escritura pública ante notario y el pago del importe total.

Tal y como establece la ley, todos los gastos e impuestos que se generen como consecuencia de la compraventa serán a cargo {compradores_minusculas}, exceptuando el impuesto municipal de plusvalía que correrá a cuenta del vendedor.

Reconoce la propiedad que el inmueble se halla libre de cargas, gravámenes y arrendatarios. Igualmente reconoce estar al corriente del pago de impuestos, tasas y comunidad que afecten al inmueble debiendo abonarlos previamente al otorgamiento de escritura pública, en caso contrario.

{compradores_etiqueta} {compradores_verbo_manifiestan} que ya {compradores_verbo_han} efectuado los trámites y estudios necesarios para la obtención, en caso de ser necesaria, de la correspondiente financiación bancaria, o bien que no necesita disponer de la misma. Por este motivo, la validez del presente documento de Arras no está sujeta a la obtención de financiación con fines hipotecarios por parte {compradores_de_preposicion} {compradores_etiqueta_lower}.

Se da a las cantidades entregadas por {compradores_etiqueta_lower} y que figuran en este contrato el carácter de arras penitenciales, pudiendo tanto {compradores_etiqueta_lower} como el vendedor en concordancia con el artículo 1.454 del Código Civil, desistir de la compraventa en cualquier momento posterior a la firma del presente documento. En el caso de desistimiento por parte {compradores_de_preposicion} {compradores_etiqueta_lower}, {compradores_pronombre} {compradores_verbo_perdera} las cantidades que hubiera puesto a disposición del vendedor en concepto de señal y pago a cuenta del precio. Si, por el contrario, desistiera el vendedor, {compradores_etiqueta_lower} {compradores_verbo_percibiiran} de ésta la cantidad que entregaron, el importe duplicado.

Y para que así conste, suscriben el presente documento, por duplicado ejemplar y a un solo efecto, en el lugar y fecha arriba indicados.

FDO. EL VENDEDOR                    FDO. {compradores_etiqueta_mayuscula}
Investments Made Easy, S.L.         {compradores_firmas}
DNI 14270239G                       {compradores_dni_firmas}
Administrador`
      },
      "fields": [
        {
          "id": "fecha_dia",
          "label": "Día de firma",
          "type": "number",
          "required": true,
          "validation": {"min": 1, "max": 31}
        },
        {
          "id": "fecha_mes",
          "label": "Mes de firma",
          "type": "select",
          "required": true,
          "options": ["enero", "febrero", "marzo", "abril", "mayo", "junio", 
                     "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
        },
        {
          "id": "fecha_año",
          "label": "Año de firma",
          "type": "number",
          "required": true,
          "validation": {"min": 2024, "max": 2030}
        },

        {
          "id": "direccion_vivienda",
          "label": "Dirección de la vivienda",
          "type": "textarea",
          "required": true,
          "placeholder": "Dirección completa de la vivienda a vender"
        },
        {
          "id": "referencia_catastral",
          "label": "Referencia catastral",
          "type": "text",
          "required": true
        },
        {
          "id": "cru_numero",
          "label": "Número CRU",
          "type": "text",
          "required": true
        },
        {
          "id": "registro_propiedad_numero",
          "label": "Número del Registro de la Propiedad",
          "type": "text",
          "required": true
        },
        {
          "id": "registro_propiedad_lugar",
          "label": "Lugar del Registro de la Propiedad",
          "type": "text",
          "required": true
        },
        {
          "id": "finca_numero",
          "label": "Número de finca",
          "type": "text",
          "required": true
        },
        {
          "id": "tomo",
          "label": "Tomo",
          "type": "text",
          "required": true
        },
        {
          "id": "libro",
          "label": "Libro",
          "type": "text",
          "required": true
        },
        {
          "id": "folio",
          "label": "Folio",
          "type": "text",
          "required": true
        },
        {
          "id": "inscripcion_numero",
          "label": "Número de inscripción",
          "type": "text",
          "required": true
        },
        {
          "id": "importe_arras",
          "label": "Importe de las arras (€)",
          "type": "number",
          "required": true,
          "validation": {"min": 0}
        },
        {
          "id": "importe_arras_letras",
          "label": "Importe de las arras en letras",
          "type": "text",
          "required": true,
          "placeholder": "Ej: cinco mil"
        },
        {
          "id": "precio_venta",
          "label": "Precio total de venta (€)",
          "type": "number",
          "required": true,
          "validation": {"min": 0}
        },
        {
          "id": "precio_venta_letras",
          "label": "Precio de venta en letras",
          "type": "text",
          "required": true,
          "placeholder": "Ej: doscientos mil"
        },
        {
          "id": "importe_reserva",
          "label": "Importe de reserva (€)",
          "type": "number", 
          "required": true,
          "validation": {"min": 0},
          "default": 3000
        },
        {
          "id": "importe_reserva_letras",
          "label": "Importe de reserva en letras",
          "type": "text",
          "required": true,
          "default": "tres mil"
        },
        {
          "id": "fecha_limite_dia",
          "label": "Día límite para escritura",
          "type": "number",
          "required": true,
          "validation": {"min": 1, "max": 31}
        },
        {
          "id": "fecha_limite_mes",
          "label": "Mes límite para escritura",
          "type": "select",
          "required": true,
          "options": ["enero", "febrero", "marzo", "abril", "mayo", "junio", 
                     "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
        },
        {
          "id": "fecha_limite_año",
          "label": "Año límite para escritura",
          "type": "number",
          "required": true,
          "validation": {"min": 2024, "max": 2030}
        }
      ]
    },
    {
      "id": "reserva_no_condicionada",
      "name": "Reserva NO condicionada a hipoteca",
      "description": "Documento de reserva sin condición hipotecaria",
      "template": {
        "title": "Documento de Reserva",
        "content": `En Barcelona a {fecha_dia} de {fecha_mes} de {fecha_año}

REUNIDOS

De una parte, la sociedad mercantil Investments Made Easy, S.L., cuyo representante legal es Joan Freixa Porredon mayor de edad, con DNI nº 14270239G y con domicilio societario en Carrer Méndez Núñez, nº 8, 08003, Barcelona (Barcelona) y C.I.F. nº B67108373

Y de otra, {compradores_info}, mayor de edad, con domicilio en {compradores_domicilios} y con número de DNI/NIE {compradores_dni_nie},

ACTÚAN

Todas las partes, en su propio nombre y se reconocen mutuamente la capacidad legal necesaria para el presente otorgamiento, y la asunción de las obligaciones que en el mismo dimanan, y de su libre y espontánea voluntad,

MANIFIESTAN

Que la sociedad mercantil Investments Made Easy, S.L. es dueña de la vivienda sita en {direccion_vivienda}, con referencia catastral número {referencia_catastral}.

Que {compradores_info} (en adelante, {compradores_etiqueta}) {compradores_verbo_estan} {compradores_verbo_interesados} en la adquisición de la finca descrita, por lo que el día de la firma del presente contrato {compradores_verbo_justifican}, mediante transferencia bancaria al número de cuenta bancaria IBAN ES11 0182 1921 21 0201542238 (BBVA) el importe de {importe_reserva}€ ({importe_reserva_letras}), en concepto de reserva para la compraventa de la vivienda.

El precio de la venta se establece en {precio_venta}€ ({precio_venta_letras}), del que deberá deducirse la cantidad total transferida hoy en concepto de reserva ({importe_reserva}€).

La reserva entregada tendrá validez máxima hasta el día {fecha_limite_arras_dia} de {fecha_limite_arras_mes} de {fecha_limite_arras_año}, día límite para formalizar las Arras penitenciales, no condicionadas a la obtención de crédito hipotecario, y fecha límite el {fecha_limite_compraventa_dia} de {fecha_limite_compraventa_mes} de {fecha_limite_compraventa_año} para la celebración de la compraventa.

La escritura se formalizará en la Notaría que a tales efectos designe la parte compradora, debiendo notificar a la parte vendedora de forma fehaciente con una antelación de, al menos, cinco días, el lugar día y hora para su otorgamiento. La parte compradora se reserva el Derecho para que la escritura pública de compraventa sea otorgada a favor de la persona que ésta libremente designe.

La entrega de llaves se llevará a cabo en el momento de la firma de la escritura pública ante notario y el pago del importe total.

Tal y como establece la ley, todos los gastos e impuestos que se generen como consecuencia de la compraventa serán a cargo {compradores_minusculas}, exceptuando el impuesto municipal de plusvalía que correrá a cuenta del vendedor.

Reconoce la propiedad que el inmueble se halla libre de cargas, gravámenes y arrendatarios. Igualmente reconoce estar al corriente del pago de impuestos, tasas y comunidad que afecten al inmueble debiendo abonarlos previamente al otorgamiento de escritura pública, en caso contrario.

La vivienda se venderá sin cargas, inquilinos ni ocupantes, al corriente de pagos y con toda la documentación que exige la ley en vigor para poder celebrar la compraventa.

Y para que así conste, suscriben el presente documento, por duplicado ejemplar y a un solo efecto, en el lugar y fecha arriba indicados.

FDO. EL VENDEDOR                    FDO. {compradores_etiqueta_mayuscula}
Investments Made Easy, S.L.         {compradores_firmas}
DNI 14270239G                       {compradores_dni_firmas}
Administrador`
      },
      "fields": [
        {
          "id": "fecha_dia",
          "label": "Día de firma",
          "type": "number",
          "required": true,
          "validation": {"min": 1, "max": 31}
        },
        {
          "id": "fecha_mes", 
          "label": "Mes de firma",
          "type": "select",
          "required": true,
          "options": ["enero", "febrero", "marzo", "abril", "mayo", "junio", 
                     "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
        },
        {
          "id": "fecha_año",
          "label": "Año de firma",
          "type": "number", 
          "required": true,
          "validation": {"min": 2024, "max": 2030}
        },
        {
          "id": "direccion_vivienda",
          "label": "Dirección de la vivienda",
          "type": "textarea",
          "required": true
        },
        {
          "id": "referencia_catastral",
          "label": "Referencia catastral",
          "type": "text",
          "required": true
        },
        {
          "id": "precio_venta",
          "label": "Precio total (€)",
          "type": "number",
          "required": true,
          "validation": {"min": 0}
        },
        {
          "id": "precio_venta_letras",
          "label": "Precio en letras",
          "type": "text",
          "required": true
        },
        {
          "id": "importe_reserva",
          "label": "Importe de reserva (€)",
          "type": "number", 
          "required": true,
          "validation": {"min": 0},
          "default": 3000
        },
        {
          "id": "importe_reserva_letras",
          "label": "Importe de reserva en letras",
          "type": "text",
          "required": true,
          "default": "tres mil"
        },
        {
          "id": "fecha_limite_arras_dia",
          "label": "Día límite para arras",
          "type": "number",
          "required": true,
          "validation": {"min": 1, "max": 31}
        },
        {
          "id": "fecha_limite_arras_mes",
          "label": "Mes límite para arras",
          "type": "select",
          "required": true,
          "options": ["enero", "febrero", "marzo", "abril", "mayo", "junio", 
                     "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
        },
        {
          "id": "fecha_limite_arras_año",
          "label": "Año límite para arras",
          "type": "number",
          "required": true,
          "validation": {"min": 2024, "max": 2030}
        },
        {
          "id": "fecha_limite_compraventa_dia",
          "label": "Día límite para compraventa",
          "type": "number",
          "required": true,
          "validation": {"min": 1, "max": 31}
        },
        {
          "id": "fecha_limite_compraventa_mes",
          "label": "Mes límite para compraventa",
          "type": "select",
          "required": true,
          "options": ["enero", "febrero", "marzo", "abril", "mayo", "junio", 
                     "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
        },
        {
          "id": "fecha_limite_compraventa_año",
          "label": "Año límite para compraventa",
          "type": "number",
          "required": true,
          "validation": {"min": 2024, "max": 2030}
        }
      ]
    },
    {
      "id": "reserva_condicionada",
      "name": "Reserva condicionada a hipoteca",
      "description": "Documento de reserva con condición hipotecaria",
      "template": {
        "title": "Documento de Reserva",
        "content": `En Barcelona a {fecha_dia} de {fecha_mes} de {fecha_año}

REUNIDOS

De una parte, la sociedad mercantil Investments Made Easy, S.L., cuyo representante legal es Joan Freixa Porredon mayor de edad, con DNI nº 14270239G y con domicilio societario en Carrer Méndez Núñez, nº 8, 08003, Barcelona (Barcelona) y C.I.F. nº B67108373

Y de otra, {compradores_info}, mayores de edad, con domicilios respectivos en {compradores_domicilios} y con números de DNI/NIE {compradores_dni_nie},

ACTÚAN

Todas las partes, en su propio nombre y se reconocen mutuamente la capacidad legal necesaria para el presente otorgamiento, y la asunción de las obligaciones que en el mismo dimanan, y de su libre y espontánea voluntad,

MANIFIESTAN

Que la sociedad mercantil Investments Made Easy, S.L. es dueña de la vivienda sita en {direccion_vivienda}, con referencia catastral número {referencia_catastral}.

Que {compradores_info} (en adelante, {compradores_etiqueta}) {compradores_verbo_estan} {compradores_verbo_interesados} en la adquisición de la finca descrita, por lo que el día de la firma del presente contrato {compradores_verbo_justifican}, mediante transferencia bancaria al número de cuenta bancaria IBAN ES11 0182 1921 21 0201542238 (BBVA) el importe de {importe_reserva}€ ({importe_reserva_letras}), en concepto de reserva para la compraventa de la vivienda.

El precio de la venta se establece en {precio_venta}€ ({precio_venta_letras}), del que deberá deducirse la cantidad total transferida hoy en concepto de reserva ({importe_reserva}€).

La reserva entregada tendrá validez máxima hasta el día {fecha_limite_arras_dia} de {fecha_limite_arras_mes} de {fecha_limite_arras_año}, día límite para formalizar las Arras penitenciales, no condicionadas a la obtención de crédito hipotecario, y fecha límite el {fecha_limite_compraventa_dia} de {fecha_limite_compraventa_mes} de {fecha_limite_compraventa_año} para la celebración de la compraventa.

La escritura se formalizará en la Notaría que a tales efectos designe la parte compradora, debiendo notificar a la parte vendedora de forma fehaciente con una antelación de, al menos, cinco días, el lugar día y hora para su otorgamiento. La parte compradora se reserva el Derecho para que la escritura pública de compraventa sea otorgada a favor de la persona que ésta libremente designe.

La entrega de llaves se llevará a cabo en el momento de la firma de la escritura pública ante notario y el pago del importe total.

Tal y como establece la ley, todos los gastos e impuestos que se generen como consecuencia de la compraventa serán a cargo {compradores_minusculas}, exceptuando el impuesto municipal de plusvalía que correrá a cuenta del vendedor.

Reconoce la propiedad que el inmueble se halla libre de cargas, gravámenes y arrendatarios. Igualmente reconoce estar al corriente del pago de impuestos, tasas y comunidad que afecten al inmueble debiendo abonarlos previamente al otorgamiento de escritura pública, en caso contrario.

Asimismo, en el caso de que {compradores_minusculas} no {compradores_verbo_logre} la correspondiente financiación con fines hipotecarios, se le devolverá la cantidad entregada como reserva.

La vivienda se venderá sin cargas, inquilinos ni ocupantes, al corriente de pagos y con toda la documentación que exige la ley en vigor para poder celebrar la compraventa.

Y para que así conste, suscriben el presente documento, por duplicado ejemplar y a un solo efecto, en el lugar y fecha arriba indicados.

FDO. EL VENDEDOR                    FDO. {compradores_etiqueta_mayuscula}
Investments Made Easy, S.L.         {compradores_firmas}
DNI 14270239G                       {compradores_dni_firmas}
Administrador`
      },
      "fields": [
        {
          "id": "fecha_dia",
          "label": "Día de firma",
          "type": "number",
          "required": true,
          "validation": {"min": 1, "max": 31}
        },
        {
          "id": "fecha_mes", 
          "label": "Mes de firma",
          "type": "select",
          "required": true,
          "options": ["enero", "febrero", "marzo", "abril", "mayo", "junio", 
                     "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
        },
        {
          "id": "fecha_año",
          "label": "Año de firma",
          "type": "number", 
          "required": true,
          "validation": {"min": 2024, "max": 2030}
        },
        {
          "id": "direccion_vivienda",
          "label": "Dirección de la vivienda",
          "type": "textarea",
          "required": true
        },
        {
          "id": "referencia_catastral",
          "label": "Referencia catastral",
          "type": "text",
          "required": true
        },
        {
          "id": "precio_venta",
          "label": "Precio total (€)",
          "type": "number",
          "required": true,
          "validation": {"min": 0}
        },
        {
          "id": "precio_venta_letras",
          "label": "Precio en letras",
          "type": "text",
          "required": true
        },
        {
          "id": "importe_reserva",
          "label": "Importe de reserva (€)",
          "type": "number", 
          "required": true,
          "validation": {"min": 0},
          "default": 3000
        },
        {
          "id": "importe_reserva_letras",
          "label": "Importe de reserva en letras",
          "type": "text",
          "required": true,
          "default": "tres mil"
        },
        {
          "id": "fecha_limite_arras_dia",
          "label": "Día límite para arras",
          "type": "number",
          "required": true,
          "validation": {"min": 1, "max": 31}
        },
        {
          "id": "fecha_limite_arras_mes",
          "label": "Mes límite para arras",
          "type": "select",
          "required": true,
          "options": ["enero", "febrero", "marzo", "abril", "mayo", "junio", 
                     "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
        },
        {
          "id": "fecha_limite_arras_año",
          "label": "Año límite para arras",
          "type": "number",
          "required": true,
          "validation": {"min": 2024, "max": 2030}
        },
        {
          "id": "fecha_limite_compraventa_dia",
          "label": "Día límite para compraventa",
          "type": "number",
          "required": true,
          "validation": {"min": 1, "max": 31}
        },
        {
          "id": "fecha_limite_compraventa_mes",
          "label": "Mes límite para compraventa",
          "type": "select",
          "required": true,
          "options": ["enero", "febrero", "marzo", "abril", "mayo", "junio", 
                     "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
        },
        {
          "id": "fecha_limite_compraventa_año",
          "label": "Año límite para compraventa",
          "type": "number",
          "required": true,
          "validation": {"min": 2024, "max": 2030}
        }
      ]
    }
  ],
  "settings": {
    "default_language": "es",
    "signature_required": true,
    "auto_save": true,
    "export_formats": ["pdf", "docx"],
    "notification_settings": {
      "send_to_buyer": true,
      "send_to_seller": true,
      "email_template": "contract_ready"
    }
  }
};

export default contractsConfig;